module.exports = __webpack_public_path__ + "img/產品資訊_產品單圖-05.16362423.png";